import { ComponentType, ReactNode } from "react";

export interface WithHiddenProps {
  hidden?: boolean;
  children?: ReactNode;
}

export function withHidden<P extends object>(Component: ComponentType<P>) {
  return function WithHiddenComponent(props: P & WithHiddenProps) {
    const { hidden, children, ...rest } = props as WithHiddenProps & P;
    if (hidden) {
      return <></>;
    }
    return <Component {...(rest as P)}>{children}</Component>;
  };
}
